<template>
  <div class="questionContainer">
    <!-- 有材料-->
    <div v-if="teskDetail.context" :style="'padding-top:' + contHeight + 'rem'">
      <div class="questionCont questionfix" :style="'max-height:' + contxtHigh + 'rem'">
        <!-- 材料 -->
        <div class="questionTitle" v-if="teskDetail.context">材料</div>
        <div class="questionTitle-context" v-if="teskDetail.context">
          <div v-for="(item, key) in teskDetail.context" :key="key">
            <div class="questionName" v-if="item.type === 'TEXT'">
              <span v-for="(text, key) in item.values" :key="key">{{ text }}</span>
            </div>
            <div class="questionName" v-if="item.type === 'HTML'" @click.stop="showImage($event)" ref="questionHtml">
              <span v-for="(ht, key) in item.values" :key="key"><span v-html="ht"></span></span>
            </div>
            <ul class="optionImg" v-if="item.type === 'IMAGE'" :class="item.values.length === 1 ? 'imgFirstList' : 'imgList'">
              <li v-for="(img, index) in item.values" :key="index" @click.stop="showPopupImage(item.values, index)">
                <img v-lazy="img" alt="">
              </li>
            </ul>
            <ul class="videoAsay" v-else-if="item.type === 'VIDEO'">
              <li v-for="(video, key) in item.values" :key="key">
                <playVideo :poster="poster1" :videoId="video"></playVideo>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 习题层级-->
      <div class="questionContentIndex">
        <div class="questionMoveImg"><img src="@/assets/img/question/icon_down.png" alt="" ></div>
        <!--    习题题目-->
        <div class="questionContent">
          <div v-for="(item, key) in teskDetail.subject" :key="key">
            <div class="questionName" v-if="item.type === 'TEXT'">
              <span class="position">{{ teskDetail.position }}</span><span class="total">/{{ teskDetail.total }}</span>
              <span v-for="(text, key) in item.values" :key="key">{{ text }}</span>
            </div>
            <div class="questionName" v-if="item.type === 'HTML'">
              <span class="position">{{ teskDetail.position }}</span><span class="total">/{{ teskDetail.total }}</span>
              <span v-for="(ht, key) in item.values" :key="key"><span v-html="ht"></span></span>
            </div>
            <div class="optionImg" v-if="item.type === 'IMAGE'">
              <ul>
                <li v-for="(img, index) in item.values" :key="index"
                    :class="item.values.length === 1 ? 'imgFirstList' : 'imgList'"
                    @click.stop="showPopupImage(item.values, index)">
                  <img v-lazy="img" alt="">
                </li>
              </ul>
            </div>
            <ul class="videoAsay" v-if="item.type === 'VIDEO'">
              <li v-for="(video, key) in item.values" :key="key">
                <playVideo :poster="poster1" :videoId="video"></playVideo>
              </li>
            </ul>
          </div>
          <!-- 主观题回答 -->
          <div class="questionName" v-if="!showSeleted && answerList">
            <span v-for="(text, key) in teskDetail.userAnswer" :key="key">{{ text }}</span>
          </div>
          <!-- 单选题 -->
          <ul class="radioList" v-if="showSeleted">
            <li v-for="(answerKey,index) in answerOption" :key="index"
                @click.stop="selectOption(answerKey)" :class="showCheckClass(answerKey)">
              <div v-for="(item, key) in optionList[answerKey]" :key="key">
                <div class="option-item-bg " :class="teskDetail.questionType==='OPINION'&&checkRight(answerKey)===1?'option-item-bg-right':''" v-if="item.type === 'TEXT'">
                  <div class="option-progress" :class="teskDetail.questionType==='OPINION'&&checkRight(answerKey)===1?'option-progress-right':''" :style="teskDetail.questionType==='OPINION' && isAnalysis ?'width:'+answerRatios[answerKey]+'%':''"></div>
                  <div class="option-item">
                    <div class="options">
                      <div class="radio">{{answerKey}}</div>
                      <div class="radio-textColor">{{ item['values'][0] }}</div>
                    </div>
                    <div class="text-progress" :class="checkRight(answerKey)===1?'text-progress-blue':''" v-show="teskDetail.questionType==='OPINION' && isAnalysis">{{answerRatios[answerKey] + '%'}}</div>
                    <div class="result">
                      <img class="icon-check-result " :class="!!answerRights&&answerRights[answerKey]===1?'checkRight':''" src="@/assets/icon/question/icon_right.png" alt="">
                      <img class="icon-check-result " :class="!!answerRights&&answerRights[answerKey]===-1?'checkWrong':''" src="@/assets/icon/question/icon_wrong.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="option-item-bg " :class="teskDetail.questionType==='OPINION'&&checkRight(answerKey)===1?'option-item-bg-right':''" v-if="item.type === 'HTML'">
                  <div class="option-progress" :class="teskDetail.questionType==='OPINION'&&checkRight(answerKey)===1?'option-progress-right':''" :style="teskDetail.questionType==='OPINION' && isAnalysis ?'width:'+answerRatios[answerKey]+'%':''"></div>
                  <div class="option-item">
                    <div class="options">
                      <div class="radio">{{answerKey}}</div>
                      <div class="radio-text" v-html="item['values'][0] && item['values'][0].replace(/(font-size)/, 'ddd')"></div>
                    </div>
                    <div class="text-progress" :class="checkRight(answerKey)===1?'text-progress-blue':''" v-show="teskDetail.questionType==='OPINION' && isAnalysis">{{answerRatios[answerKey] + '%'}}</div>
                    <div class="result">
                      <img class="icon-check-result " :class="!!answerRights&&answerRights[answerKey]===1?'checkRight':''" src="@/assets/icon/question/icon_right.png" alt="">
                      <img class="icon-check-result " :class="!!answerRights&&answerRights[answerKey]===-1?'checkWrong':''" src="@/assets/icon/question/icon_wrong.png" alt="">
                    </div>
                  </div>
                </div>
                <div class="optionImg" v-if="item.type === 'IMAGE'">
                  <ul>
                    <li v-for="(img, index) in item.values" :key="index"
                        :class="item.values.length === 1 ? 'imgFirstList' : 'imgList'"
                        @click.stop="showPopupImage(item.values, index)">
                      <img :src="img" alt="">
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 试题分析 -->
        <div class="analysisContainer" v-if="isAnalysis">
          <div class="analysisTitle">
            <div class="line"></div>
            <div>观点解析</div>
            <div class="line"></div>
          </div>
          <div class="analyAswer" v-if="teskDetail.questionType !== 'TEXT'">
            <span>我的观点：</span>
            <span>{{ answerMe }}</span>
          </div>
          <div class="analyAswer" v-if="teskDetail.questionType !== 'TEXT' && teskDetail.questionType !== 'OPINION'">
            <span>讲师观点：</span>
            <span>{{ answerText }}</span>
          </div>
          <div class="erpertOpinion">
            <div class="itemTitle">解析(仅供参考)</div>
            <div class="opinionContent"  v-for="(item, key) in answerList" :key="key">
              <div class="questionName" v-if="item.type === 'TEXT'">
                <span v-for="(text, key) in item.values" :key="key">{{ text }}</span>
              </div>
              <div class="questionName" v-if="item.type === 'HTML'" @click.stop="showImage($event, true)" ref="explainHtml">
                <span v-for="(ht, key) in item.values" :key="key"><span v-html="ht"></span></span>
              </div>
              <div class="optionImg" v-if="item.type === 'IMAGE'">
                <ul>
                  <li v-for="(img, index) in item.values" :key="index"
                      :class="item.values.length === 1 ? 'imgFirstList' : 'imgList'"
                      @click.stop="showPopupImage(item.values, index)">
                    <img :src="img" alt="">
                  </li>
                </ul>
              </div>
              <ul class="videoAsay" v-if="item.type === 'VIDEO'">
                <li v-for="(video, key) in item.values" :key="key">
                  <playVideo :poster="poster3" :videoId="video"></playVideo>
                </li>
              </ul>
            </div>
          </div>
          <!--      <div class="info">-->
          <!--        <div class="itemTitle">练习情况</div>-->
          <!--        <div class="opinionContent">骨折手术治疗适应症以下包括哪些</div>-->
          <!--      </div>-->
          <!--      <div class="konwledge">-->
          <!--        <div class="itemTitle">知识点</div>-->
          <!--        <ul class="knowledgeList">-->
          <!--          <li>标签</li>-->
          <!--          <li>标1212签</li>-->
          <!--        </ul>-->
          <!--      </div>-->
        </div>
        <!-- 主观题解答 -->
        <div class="textareaBox" v-if = "!showSeleted && !answerList">
          <van-cell-group inset>
            <van-field
              v-model="message"
              rows="1"
              type="textarea"
              :autosize="{ minHeight:minHeight }"
              placeholder="请输入答题内容"
              @input="selectInput"
            />
          </van-cell-group>
        </div>

      </div>
    </div>
    <!-- 无材料 -->
    <div class="nonequestionContent" v-else>
      <!--    习题题目-->
      <div class="questionContent">
        <div v-for="(item, key) in teskDetail.subject" :key="key">
          <div class="questionName" v-if="item.type === 'TEXT'">
            <span v-for="(text, key) in item.values" :key="key">{{ text }}</span>
          </div>
          <div class="questionName" v-if="item.type === 'HTML'">
            <span v-for="(ht, key) in item.values" :key="key"><span v-html="ht"></span></span>
          </div>
          <div class="optionImg" v-if="item.type === 'IMAGE'">
            <ul>
              <li v-for="(img, index) in item.values" :key="index"
                  :class="item.values.length === 1 ? 'imgFirstList' : 'imgList'"
                  @click.stop="showPopupImage(item.values, index)">
                <img :src="img" alt="">
              </li>
            </ul>
          </div>
          <ul class="videoAsay" v-if="item.type === 'VIDEO'">
            <li v-for="(video, key) in item.values" :key="key">
              <playVideo :poster="poster1" :videoId="video"></playVideo>
            </li>
          </ul>
        </div>
        <!-- 主观题回答 -->
        <div class="questionName" v-if="!showSeleted && answerList">
          <span v-for="(text, key) in teskDetail.userAnswer" :key="key">{{ text }}</span>
        </div>
        <!-- 单选题 -->
        <ul class="radioList" v-if="showSeleted">
          <li v-for="(answerKey,index) in answerOption" :key="index"
              @click.stop="selectOption(answerKey)" :class="showCheckClass(answerKey)">
            <div v-for="(item, key) in optionList[answerKey]" :key="key">
              <div class="option-item-bg " :class="teskDetail.questionType==='OPINION'&&checkRight(answerKey)===1?'option-item-bg-right':''" v-if="item.type === 'TEXT'">
                <div class="option-progress" :class="teskDetail.questionType==='OPINION'&&checkRight(answerKey)===1?'option-progress-right':''" :style="teskDetail.questionType==='OPINION' && isAnalysis ?'width:'+answerRatios[answerKey]+'%':''"></div>
                <div class="option-item">
                  <div class="options">
                    <div class="radio">{{answerKey}}</div>
                    <div class="radio-textColor">{{ item['values'][0] }}</div>
                  </div>
                  <div class="text-progress" :class="checkRight(answerKey)===1?'text-progress-blue':''" v-show="teskDetail.questionType==='OPINION' && isAnalysis">{{answerRatios[answerKey] + '%'}}</div>
                  <div class="result">
                    <img class="icon-check-result " :class="!!answerRights&&answerRights[answerKey]===1?'checkRight':''" src="@/assets/icon/question/icon_right.png" alt="">
                    <img class="icon-check-result " :class="!!answerRights&&answerRights[answerKey]===-1?'checkWrong':''" src="@/assets/icon/question/icon_wrong.png" alt="">
                  </div>
                </div>
              </div>
              <div class="option-item-bg " :class="teskDetail.questionType==='OPINION'&&checkRight(answerKey)===1?'option-item-bg-right':''" v-if="item.type === 'HTML'">
                <div class="option-progress" :class="teskDetail.questionType==='OPINION'&&checkRight(answerKey)===1?'option-progress-right':''" :style="teskDetail.questionType==='OPINION' && isAnalysis ?'width:'+answerRatios[answerKey]+'%':''"></div>
                <div class="option-item">
                  <div class="options">
                    <div class="radio">{{answerKey}}</div>
                    <div class="radio-text" v-html="item['values'][0] && item['values'][0].replace(/(font-size)/, 'ddd')"></div>
                  </div>
                  <div class="text-progress" :class="checkRight(answerKey)===1?'text-progress-blue':''" v-show="teskDetail.questionType==='OPINION' && isAnalysis">{{answerRatios[answerKey] + '%'}}</div>
                  <div class="result">
                    <img class="icon-check-result " :class="!!answerRights&&answerRights[answerKey]===1?'checkRight':''" src="@/assets/icon/question/icon_right.png" alt="">
                    <img class="icon-check-result " :class="!!answerRights&&answerRights[answerKey]===-1?'checkWrong':''" src="@/assets/icon/question/icon_wrong.png" alt="">
                  </div>
                </div>
              </div>
              <div class="optionImg" v-if="item.type === 'IMAGE'">
                <ul>
                  <li v-for="(img, index) in item.values" :key="index"
                      :class="item.values.length === 1 ? 'imgFirstList' : 'imgList'"
                      @click.stop="showPopupImage(item.values, index)">
                    <img :src="img" alt="">
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 试题分析 -->
      <div class="analysisContainer" v-if="isAnalysis">
        <div class="analysisTitle">
          <div class="line"></div>
          <div>观点解析</div>
          <div class="line"></div>
        </div>
        <div class="analyAswer" v-if="teskDetail.questionType !== 'TEXT'">
          <span>我的观点：</span>
          <span>{{ answerMe }}</span>
        </div>
        <div class="analyAswer" v-if="teskDetail.questionType !== 'TEXT' && teskDetail.questionType !== 'OPINION'">
          <span>讲师观点：</span>
          <span>{{ answerText }}</span>
        </div>
        <div class="erpertOpinion">
          <div class="itemTitle">解析(仅供参考)</div>
          <div class="opinionContent"  v-for="(item, key) in answerList" :key="key">
            <div class="questionName" v-if="item.type === 'TEXT'">
              <span v-for="(text, key) in item.values" :key="key">{{ text }}</span>
            </div>
            <div class="questionName" v-if="item.type === 'HTML'" @click.stop="showImage($event, true)" ref="explainHtml">
              <span v-for="(ht, key) in item.values" :key="key"><span v-html="ht"></span></span>
            </div>
            <div class="optionImg" v-if="item.type === 'IMAGE'">
              <ul>
                <li v-for="(img, index) in item.values" :key="index"
                    :class="item.values.length === 1 ? 'imgFirstList' : 'imgList'"
                    @click.stop="showPopupImage(item.values, index)">
                  <img :src="img" alt="">
                </li>
              </ul>
            </div>
            <ul class="videoAsay" v-if="item.type === 'VIDEO'">
              <li v-for="(video, key) in item.values" :key="key">
                <playVideo :poster="poster3" :videoId="video"></playVideo>
              </li>
            </ul>
          </div>
        </div>
        <!--      <div class="info">-->
        <!--        <div class="itemTitle">练习情况</div>-->
        <!--        <div class="opinionContent">骨折手术治疗适应症以下包括哪些</div>-->
        <!--      </div>-->
        <!--      <div class="konwledge">-->
        <!--        <div class="itemTitle">知识点</div>-->
        <!--        <ul class="knowledgeList">-->
        <!--          <li>标签</li>-->
        <!--          <li>标1212签</li>-->
        <!--        </ul>-->
        <!--      </div>-->
      </div>
      <!-- 主观题解答 -->
      <div class="textareaBox" v-if="!showSeleted && !answerList">
        <van-cell-group inset>
          <van-field
            v-model="message"
            rows="1"
            type="textarea"
            :autosize="{ minHeight:minHeight }"
            placeholder="请输入答题内容"
            @input="selectInput"
          />
        </van-cell-group>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import playVideo from '@com/common/VideoPlayer.vue'
import { videoReq } from "../../api";
import img1 from '@/assets/img/poster/poster1.png'
import img3 from '@/assets/img/poster/doctor.png'
import { ImagePreview } from 'vant';
import { imagePreview, appPort } from '@/widget/index'
export default defineComponent({
  props: {
    teskDetail: {
      default() {
        return {}
      },
      type: Object
    },
    selectBl: {
      type: Boolean, // 题目是否能做，true 不能做 false 能做
      default: false
    }
  },
  watch: {
    teskDetail() {
      this.showSeleted = false
      this.message = ''
      this.optionList = JSON.parse(JSON.stringify(this.teskDetail.options))
      if (this.teskDetail.ratio) {
        this.answerRatios = JSON.parse(JSON.stringify(this.teskDetail.ratio))
      }
      switch (this.teskDetail.questionType) {
        case 'BOOLEAN':
          this.showSeleted = true
          break
        case 'SINGLE':
          this.showSeleted = true
          break
        case 'MULTIPLE':
          this.showSeleted = true
          break
        case 'OPINION':
          this.showSeleted = true
          break
        default:
          break
      }
      this.isAnalysis = false
      this.answerOption = []
      this.answerRights = {}
      this.answer = {}
      this.answerList = null
      for (var key in this.optionList) {
        this.answer[key] = false
        this.answerOption.push(key)
        if (this.teskDetail.userAnswer && this.showSeleted) {
          this.answerRights[key] = this.checkRight(key)
        }
      }
      this.answerOption = this.answerOption.sort()
      if (this.teskDetail.analysis) {
        this.answerList = JSON.parse(JSON.stringify(this.teskDetail.analysis))
        if (this.answerList) {
          this.isAnalysis = true
        }
      }
      this.answerText = ''
      if (this.teskDetail.answer) {
        if (this.teskDetail.questionType !== 'TEXT' && this.teskDetail.questionType !== 'OPINION') {
          var correctAnswer = []
          for (var i in this.teskDetail.answer) {
            if (this.teskDetail.answer[i]) {
              correctAnswer.push(i)
            }
          }
          correctAnswer = correctAnswer.sort()
          this.answerText = correctAnswer.join(',')
        }
      }
      this.answerMe = ''
      if (this.teskDetail.userAnswer) {
        if (this.teskDetail.questionType !== 'TEXT') {
          var Answer = []
          for (var obj in this.teskDetail.userAnswer) {
            if (this.teskDetail.userAnswer[obj]) {
              Answer.push(obj)
            }
          }
          Answer = Answer.sort()
          this.answerMe = Answer.join(',')
        }
      }
      this.$nextTick(() => {
        let imgBox = this.$refs.questionHtml
        if (imgBox) {
          let imgs = imgBox.getElementsByTagName('img')
          let arr = []
          for (var i = 0; i < imgs.length; i++) {
            arr.push(imgs[i].src)
          }
          this.imgArr = JSON.parse(JSON.stringify(arr))
        }
        let imgBin = this.$refs.explainHtml;
        if (imgBin) {
          let imgs = imgBin.getElementsByTagName('img')
          let arr = []
          for (var j = 0; j < imgs.length; j++) {
            arr.push(imgs[j].src)
          }
          this.explainArr = JSON.parse(JSON.stringify(arr))
        }
      })
    }
  },
  data() {
    return {
      optionList: [],
      answerList: '',
      answerMsg: '',
      minHeight: 100,
      answer: {},
      showSeleted: false,
      message: '',
      isAnalysis: false,
      answerOption: [],
      answerRights: null,
      answerRatios: '',
      videoList: {},
      previewPopup: false,
      imageList: [],
      wrapperWidth: document.documentElement.clientWidth,
      picIndex: 0,
      isModel: true,
      isModelA: true,
      isModelQ: true,
      answerText: '',
      answerMe: '',
      contHeight: '8.8',
      contxtHigh: '7.5',
      imgArr: [],
      poster1: img1,
      poster3: img3,
      explainArr: [],
      videoUrl: ''
    }
  },
  methods: {
    goVideo(val) {
      this.getVideoUrl(val)
    },
    getVideoUrl(val) {
      videoReq.getVideoUrl({
        params: {
          videoId: val
        }
      }).then(res => {
        if (Number(res.code) === 200) {
          this.videoUrl = res.data.ssl_url
        }
      }).catch(error => {
        console.log(error)
      })
    },
    toggleIndex(val) {
      this.picIndex = val
    },
    showPreviewPopup(val) {
      this.previewPopup = val
      this.$nextTick(() => {
        document.scrollingElement.scrollTop = this.scrollTop
      })
    },
    showPopupImage(images, picIndex) {
      if (appPort()) {
        imagePreview({ typeId: "image_preview", images: images, posIndex: picIndex })
      } else {
        ImagePreview({
          images: images,
          closeable: true,
          startPosition: picIndex
        })
      }
    },
    selectOption(select) {
      if (this.selectBl) {
        // 题目不能做
        this.$emit('selectFn');
        return;
      }
      if (this.teskDetail.userAnswer) {
        return
      }
      if (this.teskDetail.questionType === 'BOOLEAN' || this.teskDetail.questionType === 'SINGLE' || this.teskDetail.questionType === 'OPINION') {
        for (var key in this.answer) {
          this.answer[key] = false
        }
      }
      // 多选再次点击取消选中
      if (this.answer[select]) {
        this.answer[select] = false
      } else {
        this.answer[select] = true;
      }
      this.$emit('selectFn', this.answer)
    },
    selectInput() {
      this.answerMsg = {
        Z: this.message
      }
      this.$emit('fillFn', this.answerMsg)
    },
    checkRight(key) {
      if (this.teskDetail.questionType === 'OPINION') {
        if (this.teskDetail.userAnswer && this.teskDetail.userAnswer[key] === true) {
          return 1
        } else {
          return -1
        }
      } else {
        if (this.teskDetail.answer && this.teskDetail.userAnswer) {
          if (this.teskDetail.answer[key] === true && this.teskDetail.userAnswer[key] === true) {
            return 1;
          } else if (this.teskDetail.answer[key] === false && this.teskDetail.userAnswer[key] === true) {
            return -1;
          } else if (this.teskDetail.answer[key] === true && this.teskDetail.userAnswer[key] === false) {
            return 1;
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      }
    },
    showCheckClass(key) {
      if (this.selectBl) {
        return 'gray'
      }
      if (this.teskDetail.userAnswer) {
        // 解析的时候
        if (this.teskDetail.questionType === 'OPINION') {
          if (this.checkRight(key) === 1) {
            return "rightOtherOption";
          } else {
            return "";
          }
        } else {
          if (this.checkRight(key) === 1) {
            return "rightOption";
          } else if (this.checkRight(key) === -1) {
            return "wrongOption";
          }
        }
      } else {
        if (this.answer[key]) {
          return "checked";
        } else {
          return "";
        }
      }
    },
    showImage(e, explain) {
      let target = e.target
      if (target.tagName.toLowerCase() === 'img') {
        let src = target.src
        if (explain) {
          this.showPopupImage(this.explainArr, this.explainArr.findIndex((url) => url === src))
        } else {
          this.showPopupImage(this.imgArr, this.imgArr.findIndex((url) => url === src))
        }
      }
    }
  },
  mounted() {
    this.minHeight = 2.8 * Number(localStorage.getItem('rem'))
    if (appPort()) {
      this.isModel = true
      this.isModelA = true
      this.isModelQ = true
    } else {
      this.isModel = false
      this.isModelA = false
      this.isModelQ = false
    }
  },
  components: {
    playVideo
  }
})
</script>
<style lang="scss" scoped>
  .questionContainer {
    width: 750px;
    margin: 0 auto;
    box-sizing: border-box;
    .nonequestionContent{
      padding-top: 40px;
    }
    .questionCont{
      padding: 0 32px 24px;

    }
    .questionfix{
      position: fixed;
      top: 200px;
      left: 50%;
      margin-left: -3.75rem;
      overflow-y: auto;
      z-index: 9;
    }
    .questionTitle {
      font-size: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #212224;
      line-height: 44px;
    }
    .questionTitle-context{
      padding-bottom: 20px;
      margin-bottom: 20px;
      /*border-bottom: 2px solid #E1E2E6;*/
    }
    .questionName {
      min-height: 48px;
      padding: 20px 0;
      line-height: 48px;
      font-size: 32px;
      color: #212224;
    }
    .questionContentIndex{
      background: #FFFFFF;
      box-shadow: 0px -8px 32px 0px rgba(0,0,0,0.06);
      border-radius: 30px 30px 0px 0px;
      z-index: 333;
      margin-bottom: 10px;
      position: relative;
      overflow: hidden;
      .questionMoveImg{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 24px;
        img{
          width: 160px;
          height: 50px;
        }
      }
    }
    .questionContent {
      padding: 0 32px 24px;
    }
    .videoList {
      margin-bottom: 20px;
      li {
        overflow: hidden;
        img{
          width: 100%;
        }
      }
    }
    .videoAsay{
      li {
        overflow: hidden;
        position: relative;
        .videoModel{
          position: absolute;
          z-index: 1;
          width: 686px;
          height: 386px;
          border-radius: 16px;
          background-color: transparent;
        }
      }
    }
    .optionImg{
      overflow: hidden;
      margin-right: -30px;
      padding-top: 0;
      width: 100%;
      .imgFirstList{
        // width: 250px;
        width: 100%;
        max-height: 374px;
        overflow: hidden;
        margin-bottom: 20px;
        li{
          width: 100%;
          img{
            max-width: 100%;
            border-radius: 12px;
          }
        }
        img{
          width: 100%;
          border-radius: 12px;
        }
      }
      .imgList{
        width: 100%;
        margin-right: 24px;
        margin-bottom: 24px;
        display:block;
        float: left;
        overflow: hidden;
        li{
          width: 100%;
          img{
            width: 100%;
            object-fit: cover;
            border-radius: 12px;
          }
        }
        img{
          width: 100%;
          object-fit: cover;
          border-radius: 12px;
          vertical-align: top;
        }
      }
    }
    .option-item-bg{
      background: #F5F5F7;
      border-radius: 52px;
      position: relative;
      height: auto;
    }
    .option-item-bg-right {
      background: #EFF2FD;
      height: auto;
    }
    .option-item {
      width: 686px;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 16px 30px;
      font-size: 32px;
      margin-top: 40px;
    }
    .options {
      display: flex;
      padding-right: 10px;
      overflow: hidden;
      flex: 1;
      line-height: 58px;
      align-items: center;
      .text-overflow {
        flex: 1;
      }
      .radio-text{
        min-height: 44px;
        flex: 1;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 44px;
      }
    }
    .option-progress{
      height: 100%;
      background: #E1E2E6;
      opacity: 0.5;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 8px;
    }
    .option-progress-right{
      width: 20%;
      height: 100%;
      background: #6183F2;
      opacity: 0.16;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 8px;
    }
    .text-progress{
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #969799;
    }
    .text-progress-blue{
      color: #6183F2;
    }
    .optionImg {
      padding-top: 40px;
    }
    .radioList , .checkboxList {
      overflow: hidden;
      .gray {
        color: #B0B1B2;
        .radio {
          border-color: rgba(225, 226, 230, 1);
        }
      }
      li {
        min-height: 88px;
        &.checked {
          .radio {
            background: #FF6600;
            border-color: #FF6600;
            color: #fff;
          }
          .radio-textColor{
            color:#FF6600;
          }
        }
        &.rightOption {
          .radio {
            background: #6183F2;
            border-color: #6183F2;
            color: #fff;
          }
          .result {
            display: block;
            .checkRight {
              display: block;
            }
          }
        }
        &.wrongOption {
          .radio {
            background: #F95046;
            border-color: #F95046;
            color: #fff;
          }
          .result {
            display: block;
            .checkWrong {
              display: block;
            }
          }
        }
        &.rightOtherOption{
          .radio {
            background: #6183F2;
            border-color: #6183F2;
            color: #fff;
          }
        }
        &.proportion {
          background: linear-gradient(to right, #E1E2E6 10%, #F5F5F7 0%);
          .result {
            min-width: 60px;
            display: block;
            color: #969799;
            text-align: right;
          }
        }
        &.proportionChecked {
          background: linear-gradient(to right, rgba(97,131,242, 0.16) 10%, #F5F5F7 0%);
          .radio {
            background: #6183F2;
            border-color: #6183F2;
            color: #fff;
          }
          .result {
            min-width: 60px;
            display: block;
            color: #6183F2;
            text-align: right;
          }
        }
        // checkRight
        .radio {
          width: 56px;
          height: 56px;
          text-align: center;
          line-height: 56px;
          margin-right: 24px;
          border-radius: 33px;
          border: 1Px solid rgba(225, 226, 230, 1);
          color: #969799;
          flex-shrink: 0;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
        }
        .result {
          min-width: 28px;
          height: 28px;
          display: none;
          overflow: hidden;
          img {
            display: none;
          }
        }
      }
    }
    .judgeList {
      .radio {
        margin-right: 24px;
        .checked-icon {
          display: none;
        }
      }
      .result {
        display: none;
      }
      .checked {
        .radio {
          .checked-icon {
            display: block;
          }
          .unchecked-icon {
            display: none;
          }
        }
      }
      .rightOption {
        .result {
          display: block;
          .checkRight {
            display: block;
          }
          .checkWrong {
            display: none;
          }
        }
      }
      .wrongOption {
        .result {
          display: block;
          .checkWrong {
            display: block;
          }
          .checkRight {
            display: none;
          }
        }
      }
    }
  }
  .analysisContainer {
    padding-top: 36px;
    font-size: 28px;
    .analysisTitle {
      height: 44px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 36px 32px;
      font-size: 32px;
      .line {
        border-bottom: 1Px solid #E1E2E6;
        flex: 0.4;
      }
    }
    .erpertOpinion{
      padding: 0 32px 24px;
    }
    .analyAswer{
      padding: 0 32px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #212224;
      line-height: 40px;
      margin-bottom: 16px;
      span:last-child{
        color: #6183F2;
      }
    }
    .itemTitle {
      height: 40px;
      line-height: 40px;
      font-size: 28px;
      color: #969799;
      margin-top: 40px;
    }
    .opinionContent {
      min-height: 40px;
      line-height: 40px;
    }
    .knowledgeList {
      padding: 10px 0;
      display: flex;
      flex-wrap: wrap;
      li {
        min-width: 48px;
        height: 46px;
        background: #F5F5F7;
        border-radius: 8px;
        font-size: 24px;
        color: #6183F2;
        text-align: center;
        line-height: 46px;
        margin-right: 24px;
        padding: 0 20px;
      }
    }
  }
  .textareaBox {
    margin: 0 0.24rem 0.1rem;
    height: 294px;
    border: 2px solid #E1E2E6;
    border-radius: 8px;
    box-sizing: border-box;
    overflow: hidden;
  }
</style>
